module.exports = __webpack_public_path__ + "img/nick-compressed.cbaa3cd7.jpg";